import { computed, Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AuthSessionService {
  readonly #logoutReason = signal<string | null>(null);
  readonly #loggedIn = signal<boolean | null>(null);

  public readonly logoutReason = computed<string>(() => this.#logoutReason());
  public readonly loggedIn = computed<boolean>(() => this.#loggedIn());

  setLogoutReason(reason: string | null = null): void {
    this.#logoutReason.set(reason);
  }

  setAuthenticated(isAuthenticated: boolean): void {
    this.#loggedIn.set(isAuthenticated);
  }
}
